
import {
    Box,
    Card,
    CardContent,
    Tooltip,
    Typography
} from '@mui/material';

import { InfoOutlined } from '@mui/icons-material';
import {
    getYear
} from 'date-fns';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import DateFormat from '../../utils/DateFormat';

function ClosingDaysYearCard({ sx, closingDays, workHoursRemainingClosingDays, workHoursClosingDays, flexTimeAccount, date }) {
    const year = getYear(date);
    const { t } = useTranslation();

    return (
        <>
            <Card sx={sx}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography sx={{ fontWeight: 'bold', mb: 2 }}>
                                {
                                    t('restlicheBrückentage',
                                        {
                                            ns: 'dashboardPage',
                                            year: year,
                                            defaultValue: 'Restliche Brückentage in {{year}}'
                                        }
                                    )
                                }
                            </Typography>
                            <>
                                {
                                    // manual translation because of complexity
                                    i18n.language === 'de' ?
                                        <Typography>
                                            In den verbleibenden Monaten von {date.toLocaleDateString(i18n.language, { year: 'numeric' })} {closingDays > 1 ? 'stehen ' : 'steht '}
                                            {closingDays} {closingDays > 1 ? 'Brückentage' : 'Brückentag'} an.
                                            Falls du hierfür Zeitausgleich planst, brauchst du:
                                        </Typography>
                                        :
                                        <Typography>
                                            In the remaining months of {date.toLocaleDateString(i18n.language, { year: 'numeric' })} {closingDays > 1 ? 'are ' : 'is '}
                                            {closingDays} closing {closingDays > 1 ? 'days' : 'day'} remaining.
                                            If you intend to use your working time account credit for compensation, you need:
                                        </Typography>
                                }
                            </>
                        </Box>
                        <Box>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {closingDays}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                        <Typography>{t('benötigteGleitzeit', { ns: 'dashboardPage', defaultValue: 'Für Zeitausgleich benötigte Gleitzeit' })}</Typography>
                        <Typography>{DateFormat.formatDuration(workHoursRemainingClosingDays)}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography>
                            {
                                flexTimeAccount - (workHoursRemainingClosingDays + workHoursClosingDays) >= 0 ?
                                    t('verbleibendeGleitzeit', { ns: 'dashboardPage', defaultValue: 'Verbleibendes Gleitzeitguthaben' })
                                    :
                                    t('nochAufzubauendeGleitzeit', { ns: 'dashboardPage', defaultValue: 'Noch aufzubauendes Gleitzeitguthaben' })

                            }
                            <Tooltip title={t('stundenAbgezogen', { ns: 'dashboardPage', defaultValue: 'Die Stunden, die du für Zeitausgleich in diesem Monat benötigst, sind bereits abgezogen.' })}>
                                <InfoOutlined sx={{ fontSize: 'middle', verticalAlign: 'bottom', ml: 1, color: 'gray' }} />
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ color: flexTimeAccount - (workHoursRemainingClosingDays + workHoursClosingDays) >= 0 ? 'green' : 'red' }}>
                            {flexTimeAccount - (workHoursRemainingClosingDays + workHoursClosingDays) > 0 ? '+' : ''}
                            {DateFormat.formatDuration(Math.abs(flexTimeAccount - (workHoursRemainingClosingDays + workHoursClosingDays)))}
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
};

export default ClosingDaysYearCard
